module.exports = __webpack_public_path__ + "vascular-inflammatory-and-oxidation-markers.6347d00711df429f1da0421652e55dee.png";